import { render, staticRenderFns } from "./ProductDummy.vue?vue&type=template&id=2a8eb5fc&scoped=true&"
import script from "./ProductDummy.vue?vue&type=script&lang=js&"
export * from "./ProductDummy.vue?vue&type=script&lang=js&"
import style0 from "./ProductDummy.vue?vue&type=style&index=0&id=2a8eb5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8eb5fc",
  null
  
)

export default component.exports